








import Component from 'vue-class-component';

import PageLayout from '@/common/layout/PageLayout.vue';
import { Page } from '@/layout/mixin/Page';

@Component({
  components: {
    PageLayout
  }
})
export default class CalculationPage extends Page {
  title: string = "Moduł obliczeń";
}
